import React, { useState, useEffect } from 'react'
import { useStoreActions } from 'easy-peasy'
import { useParams } from 'react-router-dom'

import { useHistory } from 'react-router-dom'

import Latency from '../Components/Latency'
import Product360Body from './Body'

const Product360 = () => {
  const { id } = useParams()
  const history = useHistory()

  const { setBreadCrumb } = useStoreActions((actions: any) => actions.breadcrumb)

  useEffect(() => {
    if (id) {
      setBreadCrumb([
        {
          title: 'Product Analytics',
          path: `/analytics/products?${history.location.search}`,
        },
        { title: 'Product 360', path: `/analytics/product360/${id}` },
      ])
      // history.push({ search: '' })
    }
  }, [setBreadCrumb, id, history])

  if (!id) return null

  return (
    <div className="AnalyticsWrapper px-8 py-7 w-full">
      <span className="text-3xl font-semibold">Product 360</span>

      <div className="mt-4">
        <Product360Body />
      </div>
    </div>
  )
}

export default Product360
